import {Component, OnInit, OnDestroy} from '@angular/core';
import {User} from '../../../../../models/user';
import {BusinessDataService} from '../../../../../data-repositories/business-data.service';
import {InfoDialogService} from '../../../../../components/info-dialog/info-dialog.service';
import {LanguageService} from '../../../../../data-repositories/language.service';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-personal-single',
  templateUrl: './personal-single.component.html',
  styleUrls: ['./personal-single.component.scss']
})
export class PersonalSingleComponent implements OnInit, OnDestroy {

  user: User;
  personalInfo: string;
  private subscription = new Subscription();

  constructor(
    private service: BusinessDataService,
    public infoDialogService: InfoDialogService,
    public langService: LanguageService) {

    this.subscription.add(this.service.GetUser().subscribe(s => {
      this.user = s.model;
    }));

    this.subscription.add(this.langService.getInfoFieldSubject().subscribe(ifm => {
      this.personalInfo = ifm.find(field => field.key === 'Personal Information').info;
    }));
  }

  ngOnInit() {
  }

  public updateUser(): void {
    this.service.updateUserWithoutValidation(this.user, () => {
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
